<template>
  <b-sidebar
    title="Шинжээч томилох"
    backdrop
    right
    shadow
    v-model="showSidebar"
    @change="visibleChanged"
    width="95vw"
    scrollable
  >
    <div class="bg-white d-flex bd-t" v-if="showSidebar">
      <div class="wd-30p">
        <div class="overflow-auto" style="height: calc(100vh - 110px)">
          <div>
            <div class="bg-light bd-y pd-y-5">
              <label
                class="tx-sans tx-uppercase tx-medium tx-10 tx-spacing-1 tx-color-03 pd-x-10 mg-b-0"
              >
                <feather type="chevron-right"></feather> Үндсэн шалгуур
              </label>
            </div>
            <div class="mg-y-10 pd-x-10">
              <div
                class="d-flex mg-b-10"
                role="button"
                @click="
                  (obj.days == 1 || obj.days == 2) && obj.too2 != 1
                    ? (allDta.keyFilter = !allDta.keyFilter)
                    : ''
                "
              >
                <div class="wd-50p text-right">Түлхүүр үг</div>
                <div class="pd-l-10">
                  <feather
                    @click="allDta.keyFilter = !allDta.keyFilter"
                    :type="`${allDta.keyFilter ? 'check-' : ''}square`"
                  ></feather>
                </div>
              </div>
              <div
                class="d-flex"
                role="button"
                @click="allDta.interestsFilter = !allDta.interestsFilter"
              >
                <div class="wd-50p text-right">Ашиг сонирхол</div>
                <div class="pd-l-10">
                  <feather
                    :type="`${allDta.interestsFilter ? 'check-' : ''}square`"
                  ></feather>
                </div>
              </div>
            </div>
          </div>

          <div v-for="(b, i) in allDta.boxSettings" :key="i">
            <div class="bg-light bd-y pd-y-5">
              <label
                class="tx-sans tx-uppercase tx-medium tx-10 tx-spacing-1 tx-color-03 pd-x-10 mg-b-0"
              >
                <feather type="chevron-right"></feather>
                {{
                  b.defaultBoxName == "" ? "Үндсэн мэдээлэл" : b.defaultBoxName
                }}
              </label>
            </div>
            <div class="mg-y-10 pd-x-10">
              <form class="el-form el-form--label-top">
                <div
                  class="el-form-item mg-b-5"
                  v-for="(f, fi) in b.searchFields"
                  :key="fi"
                >
                  <label class="el-form-item__label lh-1 mg-b-0"
                    >{{ f.title }}
                  </label>
                  <div class="el-form-item__content">
                    <!-- <div v-if="f.flag==1" class="el-input">
                          <input v-model="f.value" type="text" autocomplete="off" class="el-input__inner" />
                        </div> -->

                    <Input
                      v-if="f.flag == 1"
                      v-model="f.value"
                      :key="`in_${f.fieldId}_${f.i1}`"
                      :disabled="
                        (obj.days == 1 || obj.days == 2) && obj.too2 != 1
                      "
                    />

                    <loc-type-cascader
                      :key="`lt_${f.fieldId}_${f.i1}`"
                      @loctype-selected_withdata="ltChanged(f, $event)"
                      v-else-if="f.flag == 3"
                      v-model="f.value"
                      :multiple="f.multiple"
                      :getParentType="true"
                      :checkStrictly="true"
                      :locTypekey.sync="f.key"
                      disableAdd
                      :disabled="
                        (obj.days == 1 || obj.days == 2) && obj.too2 != 1
                      "
                    />
                    <Select
                      v-else-if="f.flag == 5"
                      class="wd-100p"
                      v-model="f.value"
                      :key="`sl_${f.fieldId}_${f.i1}`"
                      :disabled="
                        (obj.days == 1 || obj.days == 2) && obj.too2 != 1
                      "
                    >
                      <Option label="Бүгд" :value="null"></Option>
                      <Option label="Тийм" :value="1"></Option>
                      <Option label="Үгүй" :value="0"></Option>
                    </Select>
                    <div v-else>{{ f.flag }}</div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="ht-55 bd-t d-flex align-items-center pd-x-10 bg-light">
          <a
            @click="projectMention.show = true"
            v-if="
              hasPermission(['stf_proj_assignredo']) &&
                (obj.days == 1 || obj.days == 2) &&
                obj.too2 != 1
            "
            class="btn btn-warning"
          >
            <feather type="menu"></feather>
          </a>
          <a
            @click="reject.modal = true"
            v-if="
              hasPermission(['stf_proj_assignredo']) &&
                (obj.days == 1 || obj.days == 2) &&
                obj.too2 != 1
            "
            class="btn btn-danger"
            >Шинжээч цуцлах</a
          >
          <template v-if="obj.days == null || obj.days == 0 || obj.too2 == 1">
            <div class="btn-group">
              <a @click="resetClear()" class="btn btn-light"
                >Хайлтыг цэвэрлэх</a
              >
              <a @click="doSearchSleep()" class="btn btn-primary">Хайх</a>
            </div>
            <!-- <a @click="saveResult()" class="btn btn-success mg-l-auto">Үр дүнг хадгалах</a> -->

            <div :class="`dropdown dropup mg-l-auto `">
              <a
                href
                class="btn btn-secondary dropdown-toggle"
                data-toggle="dropdown"
              >
                Хадгалах
              </a>
              <div class="dropdown-menu dropdown-menu-right tx-13">
                <a
                  @click="saveResultRe()"
                  class="dropdown-item pd-l-0-f mg-t-0-f"
                  role="button"
                >
                  <feather
                    type="users"
                    class="ht-20-f ht-20-f mg-r-5"
                    style="width: 20px; height: 20px;"
                  ></feather
                  >Хадгалааад дахин хайх
                </a>
                <a
                  @click="saveResult()"
                  class="dropdown-item pd-l-0-f mg-t-0-f"
                  role="button"
                >
                  <feather
                    type="check-square"
                    class="ht-20-f ht-20-f mg-r-5"
                    style="width: 20px; height: 20px;"
                  ></feather
                  >Үр дүнг хадгалах
                </a>
              </div>
            </div>

            <!-- <div class="dropdown dropdown-profile dropup mg-l-auto">
                  <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Хадгалах
                  </button>
                  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <a class="dropdown-item" href="#">Хадгалааад дахин хайх</a>
                    <a class="dropdown-item" href="#">Үр дүнг хадгалах</a>
                  </div>
                </div> -->
          </template>
          <a
            v-else-if="obj.days == 1"
            @click="saveAssign()"
            class="btn btn-success mg-l-auto"
            >Шинжээч томилох</a
          >
          <a
            v-else-if="obj.days == 2"
            @click="viewPoints()"
            class="btn btn-success mg-l-auto"
          >
            <span
              v-if="
                obj.organizationTask.locTypeId == 251286 ||
                  obj.organizationTask.locTypeId == 162068
              "
            >
              Шинжээчдийн үнэлгээ нэгтгэл
            </span>
            <span v-else>үнэлгээтэй танилцах</span>
          </a>
        </div>
      </div>
      <div class="wd-70p bg-light bd-l">
        <div v-if="loading" class="container ht-100p">
          <div
            class="ht-100p d-flex flex-column align-items-center justify-content-center"
          >
            <div class="wd-150 wd-sm-250 mg-b-10">
              <img
                src="https://res.gosmart.mn/apps/stf/assign.svg"
                class="img-fluid"
                alt=""
              />
            </div>
            <img
              src="https://res.gosmart.mn/apps/stf/loading.svg"
              class="wd-100"
            />
            <h4 class="tx-20 tx-sm-24">Ачааллаж байна түр хүлээнэ үү</h4>
            <p class="tx-color-03 mg-b-40">
              Шинжээчийн мэдээллийн сангаас тохирох өгөгдлийн дагуу
              боловсруулалт хийж байна.
            </p>
            <!-- <div class="tx-13 tx-lg-14 mg-b-40">
                    <a href="" class="btn btn-brand-02 d-inline-flex align-items-center">Resend Verification</a>
                    <a href="" class="btn btn-white d-inline-flex align-items-center mg-l-5">Contact Support</a>
                  </div>
                  <span class="tx-12 tx-color-03">Mailbox with envelope vector is created by <a href="https://www.freepik.com/free-photos-vectors/background">freepik (freepik.com)</a></span> -->
          </div>
        </div>
        <div v-else class="container">
          <div class="card ht-50p">
            <div
              class="card-header d-flex align-items-center justify-content-between pd-r-10"
            >
              <h6 class="mg-b-0">Хайлтын үр дүн</h6>
              <div class="input-group wd-50p">
                <div class="input-group-prepend">
                  <button
                    class="btn btn-icon btn-outline-light btn-xs"
                    @click="filterByNameMethodClear()"
                  >
                    <i
                      data-v-4d521fc4=""
                      data-name="x"
                      data-tags="cancel,close,delete,remove,times,clear"
                      data-type="x"
                      class="feather feather--x"
                      ><svg
                        data-v-4d521fc4=""
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="feather feather-x feather__content"
                      >
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line></svg
                    ></i>
                  </button>
                </div>
                <input
                  type="text"
                  @keyup="filterByNameMethod()"
                  placeholder="Хайлтад илэрсэн шинжээчдээс нэрээр шүүх"
                  v-model="filterByNameTxt"
                  class="form-control"
                  style="width: auto;"
                />
                <div class="input-group-append">
                  <button
                    @click="filterByNameMethod()"
                    class="btn btn-icon btn-outline-light btn-xs"
                  >
                    <i
                      data-v-4d521fc4=""
                      data-name="search"
                      data-tags="find,magnifier,magnifying glass"
                      data-type="search"
                      class="feather feather--search"
                      ><svg
                        data-v-4d521fc4=""
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="feather feather-search feather__content"
                      >
                        <circle cx="11" cy="11" r="8"></circle>
                        <line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg
                    ></i>
                  </button>
                </div>
              </div>
            </div>
            <ul
              class="list-group list-group-flush tx-13 overflow-auto"
              style="height: calc(50vh - 150px)"
            >
              <li
                @click="
                  handleUserInfoModalObj({
                    id: u.id,
                    keys: true,
                    tags: obj.tagList,
                  })
                "
                role="button"
                v-for="(u, ui) in users"
                :key="ui"
                class="list-group-item d-flex pd-x-20"
              >
                <div
                  v-if="obj.days == 1"
                  class="bd-r bd-3 tx-20 pd-t-5 text-center wd-50 mg-r-20"
                >
                  {{ u.irtsPerc }}
                </div>
                <div
                  v-else
                  class="bd-r bd-3 tx-20 pd-t-5 text-center wd-50 mg-r-20"
                >
                  {{ u.matchedKeyCount }}
                </div>

                <div class="avatar">
                  <img
                    :src="`${u.avator}?=w60`"
                    class="rounded-circle"
                    alt=""
                  />
                </div>
                <div class="pd-l-10">
                  <p class="tx-medium mg-b-0">{{ u.task }} {{ u.lat }}</p>
                  <small class="tx-12 tx-color-03 mg-b-0">{{ u.mobile }}</small>
                </div>
                <div class="mg-l-auto d-flex align-self-center">
                  <!-- {{ u.executeFlag }} -->
                  <div
                    v-if="u.executeFlag == 0"
                    style="color: #fff !important; background-color: RGBA(103, 119, 147, var(--bs-bg-opacity, 1)) !important; border-radius: 5px"
                  >
                    <span class="badge text-bg-secondary"
                      >Илгээсэн хэрэглэгч</span
                    >
                  </div>
                  <nav
                    v-else-if="obj.days == 1 && obj.too2 != 1"
                    class="nav nav-icon-only"
                  >
                    <a
                      @click.stop="u.executeFlag = -10"
                      v-if="u.executeFlag == 10"
                      class="btn btn-warning"
                    >
                      <feather type="check-square"></feather> Шинжээчээс хасах
                    </a>
                    <a
                      @click.stop="u.executeFlag = 10"
                      v-else-if="u.executeFlag == -10"
                      class="btn btn-light"
                    >
                      <feather type="square"></feather> Шинжээчээр томилох
                    </a>
                  </nav>
                  <nav v-else-if="obj.days == 2" class="nav nav-icon-only">
                    <a v-if="u.executeFlag == 10" class="btn btn-success">
                      <feather type="check-square"></feather> Шинжээчээр
                      томилогдсон
                    </a>
                  </nav>
                </div>
              </li>
            </ul>
            <div class="card-footer text-center tx-13">
              <a
                v-if="obj.days == 1"
                href=""
                class="link-03 d-inline-flex align-items-center"
              >
                {{ users.filter((x) => x.executeFlag == 10).length }}/{{
                  users.length
                }}
              </a>
              <a
                v-else
                href=""
                class="link-03 d-inline-flex align-items-center"
              >
                {{
                  users.length < usersCount
                    ? users.length + "/" + usersCount
                    : usersCount
                }}
              </a>
            </div>
            <!-- card-footer -->
          </div>

          <div
            class="card ht-50p pd-10 mg-t-20"
            style="padding-top: 0px; padding-bottom: 0px;"
          >
            <div class="mg-b-10">
              <nav class="nav nav-line tx-medium" role="tablist">
                <a
                  class="nav-link active"
                  data-bs-toggle="tab"
                  aria-selected="true"
                  role="tab"
                  >Хайсан шалгуур үзүүлэлтүүд</a
                >
                <a
                  @click="openSubSearches()"
                  href="javascript:void(0)"
                  class=" btn btn-xs btn-warning"
                  style="margin-left: auto"
                  v-if="obj.b.filter((x) => x.ot == 597 && x.taskCount > 0)"
                  ><b>{{ users.length }}</b> хэрэглэгчийг
                  <b>{{ obj.b.filter((x) => x.ot == 597)[0]["taskCount"] }}</b>
                  удаагийн хайлтаар сонгосон байна. Энд дарж харна уу
                </a>
              </nav>
            </div>
            <div class="overflow-auto" style="height: calc(40vh - 20px)">
              <table
                class="table table-sm tx-13 mg-b-0 table-striped"
                v-if="
                  obj.b.filter((x) => x.ot == 597).length == 0 ||
                    (subsrchObj.cur.id != undefined && subsrchObj.cur.id > 0)
                "
              >
                <tbody>
                  <template
                    v-for="(b, i) in allDta.boxSettings.filter(
                      (x) => x.searchFields.length
                    )"
                  >
                    <tr :key="`sr_${i}`">
                      <td
                        class="bg-light wd-35p align-middle text-muted-xl"
                        :rowspan="b.searchFields.length + 1"
                      >
                        {{ i + 1 }}.
                        {{
                          b.defaultBoxName == ""
                            ? "Үндсэн мэдээлэл"
                            : b.defaultBoxName
                        }}
                      </td>
                    </tr>
                    <tr
                      v-for="(f, fi) in b.searchFields"
                      :key="`srf_${i}_${fi}`"
                    >
                      <td class="wd-20 align-middle pd-l-10-f">
                        <div
                          :class="
                            `wd-15 ht-15 rounded-circle bd bd-3 bd-${
                              f.value != null && f.value != '' && f.value != 0
                                ? 'primary'
                                : 'light'
                            }`
                          "
                        ></div>
                      </td>
                      <td
                        :class="
                          `tx-medium ${
                            f.value != null && f.value != '' && f.value != 0
                              ? ''
                              : 'text-muted'
                          }`
                        "
                      >
                        {{ i + 1 }}.{{ fi + 1 }}. {{ f.title }}
                      </td>
                      <td class="text-right pd-r-0-f">{{ f.valueText }}</td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      v-model="pnts.modal"
      size="xl"
      title="Шинжээчдийн үнэлгээ өгсөн байдал"
      scrollable
      hide-footer
    >
      <table class="table table-bordered table-striped">
        <thead>
          <tr>
            <th class="font-weight-bold">Шалгуур үзүүлэлт</th>
            <th
              @click="
                handleUserInfoModalObj({
                  id: u.id,
                  keys: true,
                  tags: obj.tagList,
                })
              "
              role="button"
              v-for="(u, ui) in users.filter((x) => x.executeFlag == 10)"
              :key="ui"
            >
              <div class="d-flex align-items-center">
                <div class="bd pd-2 bg-white rounded-circle">
                  <img
                    :src="`${u.avator}?=w20`"
                    class="wd-20 rounded-circle"
                    alt=""
                  />
                </div>
                <div class="pd-l-10">{{ u.displayName }}</div>
              </div>
            </th>
            <th class="font-weight-bold">Нийт</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(t, ti) in pnts.types" :key="ti">
            <th>{{ ti + 1 }}. {{ t.shalguurName }}</th>
            <td
              :class="
                `text-center tx-16 ${
                  u[t.fieldName] > 0 ? 'bg-success tx-white' : ''
                }`
              "
              v-for="(u, ui) in users.filter((x) => x.executeFlag == 10)"
              :key="ui"
            >
              {{ u[t.fieldName] }}
              <a
                class="link tx-12"
                @click="vuewExecution(u[t.descFieldName], t.shalguurName)"
                >тайлбар</a
              >
            </td>
            <td class="font-weight-bold text-right">
              {{
                users
                  .filter((x) => x.executeFlag == 10)
                  .reduce((sum, st) => sum + parseInt(st[t.fieldName]), 0)
              }}
            </td>
          </tr>
          <tr class="font-weight-bold">
                <th  class="text-right">Нийт</th>
                <td class="text-center" v-for="(x,ui) in users.filter(x=>x.executeFlag==10)" :key="ui">
                  <span>
                    {{
                      ((x.i1) 
                  + (x.i2 ) 
                  + (x.i3 )                   
                  + (x.i4 ) 
                  + (x.i5 )
                  + (x.pinX ) 
                  + (x.pinY ) 
                  + (x.yavtsPerc ) 
                  + (x.examPerc ) 
                  + (x.reminderValue ) 
                  + (x.examPoint ))
                    }}
                  </span>
                  <!-- {{
                users
                  .filter((x) => x.executeFlag == 10 && u.userId == x.userId)
                  .reduce((sum, st) => sum + parseInt(st[t.fieldName]), 0)
              }} -->
                  <!-- {{
                users
                  .filter((x) => x.executeFlag == 10 && x.userId==u.userId)
                  .reduce((sum, st) => sum + parseInt(st[t.fieldName]), 0)
              }} -->
                  <!-- <template v-for="(t,ti) in pnts.types"  >
                    <span :key="`iti_${ti}`">
                      {{t.fieldName}}
                    </span>
                    
                  </template> -->
                </td>
              </tr>
          <tr>
            <td></td>
            <td
              class="text-center"
              v-for="(u, ui) in users.filter((x) => x.executeFlag == 10)"
              :key="ui"
            >
              <a
                @click="setMark(u)"
                class="tx-primary tx-rubik mg-b-0"
                role="button"
                >Үнэлгээ оруулах</a
              >
              <div>
                <a
                  @click="vuewExecution(u.execution, 'Дүгнэлт')"
                  class="tx-rubik mg-b-0"
                  role="button"
                  >Дүгнэлт харах</a
                >
              </div>
            </td>
            <td></td>
          </tr>
          <tr>
            <td>АШИГ СОНИРХЛЫН МЭДЭГДЭЛ</td>
            <td
              v-for="(u, ui) in users.filter((x) => x.executeFlag == 10)"
              :key="ui"
            >
              <a
                role="button"
                v-show="u.attachmentId > 0"
                @click="showFilePreview(u.attachmentId)"
                >Бөглөсөн маягт хуудас 1</a
              ><br />
              <a
                role="button"
                v-show="u.secondAttachmentId > 0"
                @click="showFilePreview(u.secondAttachmentId)"
                >Бөглөсөн маягт хуудас 2</a
              >
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>

      <div class="d-flex">
        <div>Нэгдсэн дүнгийн хүснэгт файлаар хуулах</div>
        <div>
          <simple-uploader
            :propObjectId="6"
            :propObjectTypeId="6"
            @on-success="fileUploadedSetting"
            class="wd-100p"
          >
            <div slot="trigger" class="wd-100p">
              <a
                v-if="
                  markLast.thirdAttachmentId == 0 ||
                    markLast.thirdAttachmentId == null
                "
                class="dropdown-item"
                >Компьютероос хуулах
              </a>
              <div v-else class="btn-group wd-100p">
                <!-- <div class="btn btn-outline-success" @click.stop="dtl.modal = false; $emit('on-attach', markLast.thirdAttachmentId)">
                    <feather type="eye"></feather>Файл харах
                  </div> -->
                <div
                  class="btn btn-danger"
                  @click.prevent.stop="markLast.thirdAttachmentId = null"
                >
                  <feather type="x"></feather>Салгах
                </div>
              </div>
            </div>
          </simple-uploader>
        </div>
        <div>
          <div class="btn btn-primary" @click="postThird()">
            <feather type="check"></feather> Хадгалах
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      v-model="markObj.modal"
      body-class="test-modal-body bg-light ht-100v"
      dialog-class="test-modal-dialog"
      centered
      scrollable
      size="lg"
      title="Үнэлгээ өгөх"
    >
      <div class="ht-100v">
        <div class="d-flex">
          <div class="wd-50p pd-20">
            <task-info
              class="wd-100p bg-white rounded-20 bd pd-20"
              :fields="markObj.fields"
              :obj="{ data: { task: markObj.task } }"
              :loaded="markObj.fetched"
              :boxId="0"
              :parentTask="null"
              @on-attach="showFile"
            />
          </div>
          <div class="wd-50p pd-20" v-if="markObj.fetched">
            <div class="wd-100p bg-white rounded-20 bd pd-20">
              <table class="table table-bordered table-striped wd-100p">
                <thead class="font-weight-bold">
                  <th>Шалгуур үзүүлэлтүүд</th>
                  <th class="wd-50">Таны үнэлгээ</th>
                  <th class="wd-50">Боломжит хамгийн их оноо</th>
                </thead>
                <tbody>
                  <template v-for="(p, i) in pointsDta.points">
                    <tr :key="`tr_${i}`">
                      <td>{{ p.shalguurName }}</td>
                      <td style="width: 50px" class="wd-50">
                        <InputNumber
                          :min="0"
                          :max="p.maxPoint"
                          v-model="p.point"
                        />
                      </td>
                      <td class="wd-50">{{ p.maxPoint }}</td>
                    </tr>
                    <tr :key="`tr1_${i}`">
                      <td colspan="3">
                        <textarea
                          v-model="p.desc"
                          class="form-control"
                          placeholder="Тайлбар бичнэ үү"
                        ></textarea>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>

              <div>
                Үнэлгээ өгсөн тайлбар энд бичнэ үү
                <textarea
                  class="form-control"
                  rows="6"
                  v-model="pointsDta.execution"
                ></textarea>
              </div>
            </div>
            <!-- {{ markObj.task.b.length }}
                    <div v-for="(b, i) in markObj.task.b" :key="i">{{ b.otCompName }}</div> -->
            <!-- <h1>энд box зурах гээд bug тай үлдээсэн :D</h1> -->
            <div v-for="(b, i) in markObj.task.b" :key="i">
              <loader
                :ref="`ldr_box_${b.id}`"
                :box="b"
                :prms="{ boxChooser: false }"
                :detailSettingProp="{
                  boxSetting: {
                    listSetting: { height: 0 },
                    hideToolbar: true,
                    hideEmptyTemplate: true,
                    autoHeight: true,
                    hideFooter: true,
                  },
                }"
                @on-attach="showFile($event)"
                @on-detail="showDetail"
                @load-box="loadBoxData"
              />
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100">
          <!-- <p class="float-left">энд тайлбар бичнэ88</p> -->
          <b-button
            v-if="$store.state.user.userInfo.user_name == 'park'"
            variant="primary"
            size="sm"
            class="float-right"
            @click="postPoints()"
          >
            Үр дүнг хадгалах
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal v-model="execMdl" :title="execTitle" centered hide-footer>
      <div>{{ execTxt }}</div>
    </b-modal>

    <b-modal v-model="reject.modal" title="Шинжээч цуцлах" centered hide-footer>
      <div>
        <div>
          <div class="form-group">
            <label for="formGroupExampleInput" class="d-block"
              >Тайлбар бичнэ үү</label
            >
            <textarea
              v-model="reject.reason"
              class="form-control"
              rows="2"
              placeholder="тайлбар"
            ></textarea>
          </div>

          <div class="alert alert-warning" role="alert">
            <h4 class="alert-heading">Санамж</h4>
            <p>Тайлбарыг 50-с дээш тамдэгтээр дэлгэрэнгүй бичнэ үү</p>
          </div>

          <div class="btn-group">
            <button class="btn btn-primary" @click="rejectShinjeech">
              Цуцлах
            </button>
            <button class="btn btn-secondary" @click="reject.modal = false">
              Болих
            </button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal v-model="subsrchObj.modal" title="Хайлтууд" centered hide-footer>
      <ul class="list-group">
        <li
          @click="subSearchView(t)"
          class="list-group-item d-flex"
          role="button"
          v-for="(t, si) in subsrchObj.tasks"
          :key="si"
        >
          {{ si + 1 }}. {{ t.task }}
          <div class="mg-l-auto tx-12">
            {{ t.createdDate | moment("yyyy.MM.DD HH.mm") }}
          </div>
        </li>
      </ul>
    </b-modal>

    <file-dialog
      :zindex="99999"
      :show="fileDialog.show"
      :id="fileDialog.id"
      @on-hide="fileDialog.show = false"
    />

    <b-modal v-model="filePreview.modal" hide-footer size="lg" scrollable body-class="pd-0">
      <!-- <template v-if="fileDialog.blank">
        <img class="wd-100p" :src="fileDialog.src" />
      </template> -->
      <file-preview :minusHeight="400"
        :show="filePreview.show"
        :id.sync="filePreview.id"
        @on-hide="filePreview.show = false"
        :force="true"
      />
    </b-modal>

    <mention-users
      :show="projectMention.show"
      :obj.sync="obj"
      :module="projectMention.module"
      @on-force="$emit('on-assign-close')"
      @on-mention-close="projectMention.show = false"
    ></mention-users>
  </b-sidebar>
</template>

<script>
import { request } from "@/api/all";
var _ = require("lodash");
import { mapActions } from "vuex";

import "element-ui/lib/theme-chalk/index.css";
import {
  Notification,
  Select,
  Option,
  Input,
  InputNumber,
  MessageBox,
} from "element-ui";

import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import { getDetailFields } from "@/api/taskCore";
import loader from "@/components/box/loader/loader.vue";

import { hasOneOf } from "@/libs/tools";

export default {
  components: {
    loader,
    Select,
    Option,
    Input,
    InputNumber,
    MessageBox,
    mentionUsers: () => ({
      component: import("@/components/project/mentionstf.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    simpleUploader: () => ({
      component: import("@/components/modules/media/simpleUploader.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    taskInfo: () => ({
      component: import("@/components/task/detail/ot/components/info.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    locTypeCascader: () => ({
      component: import("@/components/task/edit/components/locTypeCascader"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    fileDialog: () => ({
      component: import("@/components/modules/media/preview.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    filePreview: () => ({
      component: import("@/components/modules/media/previewPage.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  name: "projectUsers",
  data: () => ({
    subsrchObj: {
      tasks: [],
      modal: false,
      cur: {},
    },
    projectMention: {
      module: "members",
      show: false,
    },
    reject: {
      reason: null,
      modal: false,
    },
    filterByNameTxt: "",
    execMdl: false,
    execTxt: "",
    execTitle: "",
    markLast: {
      thirdAttachmentId: null,
    },
    fileDialog: {
      id: null,
      show: false,
    },
    filePreview: {
      id: null,
      show: false,
      modal: false,
    },
    pointsDta: {
      points: [],
      projectTaskId: null,
      userId: null,
      execution: null,
    },
    markObj: {
      fields: [],
      task: {
        b: [],
      },
      id: null,
      modal: false,
      fetched: false,
    },
    showSidebar: false,
    users: [],
    usersTemp: [],
    usersCount: null,
    fetched: false,
    //boxes:[],
    allDta: {
      projectTaskId: 0,
      boxSettings: [],
      keyFilter: false,
      interestsFilter: false,
    },
    loading: false,
    pnts: {
      modal: false,
      types: [],
    },
  }),
  props: {
    obj: {
      type: Object,
      default: () => {},
    },
    show: {
      type: Boolean,
      default: () => false,
    },
    module: {
      type: Number,
      default: () => 0,
    },
  },
  watch: {
    show: function(newVal) {
      if (newVal) {
        this.canSettings();
      } else {
        this.showSidebar = false;
      }
    },
    obj: function(newVal) {
      console.log("newVal", newVal);
      if (
        (this.showSidebar &&
          newVal.days != undefined &&
          (newVal.days == 1 || newVal.days == 2)) ||
        (this.showSidebar && newVal.too2 != undefined && newVal.too2 == 1)
      ) {
        console.log("w1");
        if (newVal.days == 1 || newVal.too2 == 1) {
          console.log("w2");
          this.fetchAssignedMembers();
        } else {
          this.init();
        }
      }
    },
  },
  mounted() {},
  methods: {
    hasPermission(arr) {
      if (this.$store.state.user.userId == "") return false;
      return hasOneOf(this.$store.state.user.userInfo.access, arr);
    },
    subSearchView(task) {
      this.allDta = JSON.parse(task.s1);
      this.subsrchObj.cur = task;
      this.subsrchObj.modal = false;
    },
    openSubSearches() {
      const _boxId = this.obj.b.filter((x) => x.ot == 597)[0]["id"];
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "taskCore/CoreBoxInTaskList" },
        data: {
          id: _boxId,
          skip: 0,
          size: 5000,
          model: {},
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          // console.log('res', res);
          this.subsrchObj.tasks = res.data.tasks;
          this.subsrchObj.modal = true;
        }
      });
    },
    rejectShinjeech() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "projectEdu/DeleteShinjeech" },
        data: {
          id: this.obj.id,
          otCompName: this.reject.reason,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.visibleChanged(false);
          this.reject.modal = false;
          Notification.success({
            message: "Амжилттай шинжээч цуцаллаа",
            duration: 5000,
          });
          //console.log("res", res);
        }
      });
    },
    filterByNameMethodClear() {
      this.filterByNameTxt = "";
      this.users = this.usersTemp;
    },
    filterByNameMethod() {
      //this.usersTemp = this.users;
      //this.usersTemp = this.users;
      this.users = this.usersTemp.filter(
        (x) =>
          x.task.toLowerCase().indexOf(this.filterByNameTxt.toLowerCase()) > -1
      );
    },
    postThird() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "ProjectEdu/SaveThirdAttachmentId" },
        data: {
          id: this.obj.id,
          thirdAttachmentId: this.markLast.thirdAttachmentId,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          Notification.success({
            message: "Амжилттай",
            duration: 5000,
          });
          //console.log("res", res);
        }
      });
    },
    fileUploadedSetting(e) {
      this.markLast.thirdAttachmentId = e.uploadedAttachmentId;
    },
    showDetail() {},
    loadBoxData() {},
    showFile(e) {
      // console.log('e', e);
      this.markObj.modal = false;
      this.fileDialog.id = e;
      this.fileDialog.show = true;
    },
    showFilePreview(e) {
      // console.log('e', e);
      this.markObj.modal = false;
      this.filePreview.id = e;
      this.filePreview.show = true;
      this.filePreview.modal = true;
    },
    postPoints() {
      MessageBox.confirm(
        "Та үнэлгээг хадгалахдаа итгэлтэй байна уу ?",
        "Санам",
        {
          confirmButtonText: "Тийм",
          cancelButtonText: "Үгүй",
          type: "warning",
        }
      )
        .then(() => {
          this.toggleBodyClass("addClass", "dynamic-locker");
          request({
            api: {
              method: "POST",
              url: "ProjectEdu/SetMyPointsByProjectTaskId",
            },
            data: this.pointsDta,
            store: this.$store,
          }).then((res) => {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            if (res != false) {
              //console.log("res", res);
              this.markObj.modal = false;
              //this.viewPoints();
              this.fetchAssignedMembers();
            }
          });
        })
        .catch(() => {});
    },
    getMyPoints(id, userId) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "ProjectEdu/GetMyPointsByProjectTaskId" },
        params: {
          projectTaskId: id,
          userId: userId,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.pointsDta = res.data;
          this.pointsDta.userId = userId;
          // this.viewPoints();
          //this.doSearch();
          //console.log('res', res);
        }
      });
    },
    vuewExecution(exec, title) {
      this.execTxt = exec;
      this.execTitle = title;
      this.execMdl = true;
    },
    setMark(user) {
      //console.log('user', user, this.obj);

      this.toggleBodyClass("addClass", "dynamic-locker");
      getDetailFields({ params: { objectTypeId: 561 } }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.markObj.fields = res.data.fields;
          this.markObj.fetched = true;
          this.toggleBodyClass("addClass", "dynamic-locker");
          request({
            api: { method: "GET", url: "task/TaskInheritedDetail" },
            params: { id: this.obj.id },
            store: this.$store,
          }).then((rest) => {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            if (rest != false) {
              this.markObj.task = rest.data.task;
              //this.markObj.task.b.unshift({id: 0, nm: 'Ерөнхий мэдээлэл'});

              this.markObj.id = this.obj.id;
              this.markObj.modal = true;

              this.getMyPoints(this.obj.id, user.userId);
            }
          });
        }
      });
    },
    ...mapActions(["handleUserInfoModal", "handleUserInfoModalObj"]),
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    canSettings() {
      this.init();
    },
    ltChanged(field, e) {
      field.valueText = e.data.title;
      //console.log(field, e.data.title);
    },
    init() {
      request({
        api: { method: "GET", url: "TaskCore/GetBoxesWithSearchFields" },
        params: {
          objectTypeId: this.module,
          taskId: this.obj.id,
        },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.fetched = true;
          this.allDta = res.data;
          this.allDta.boxSettings = this.allDta.boxSettings.filter(
            (x) =>
              x.boxObjectTypeId == 138 ||
              x.boxObjectTypeId == 140 ||
              x.boxObjectTypeId == 139 ||
              x.boxObjectTypeId == 148 ||
              x.boxObjectTypeId == 581 ||
              x.boxObjectTypeId == 149 ||
              x.boxObjectTypeId == 316 ||
              x.boxObjectTypeId == 151 ||
              x.boxObjectTypeId == 377 ||
              x.boxObjectTypeId == 455
          );
          //console.log('GetBoxesWithSearchFields ', res.data);

          if (this.obj.days == 1 || this.obj.days == 2 || this.obj.too2 == 1) {
            this.fetchAssignedMembers();
          } else {
            this.showSidebar = true;
          }
        } else {
          this.fetched = false;
          this.visibleChanged(false);
        }
      });
    },
    resetClear() {
      this.allDta.projectTaskId = this.obj.id;
      this.allDta.boxSettings.forEach(function(part, bi, box) {
        box[bi]["searchFields"].forEach(function(part2, fi, field) {
          field[fi]["value"] = null;
          field[fi]["valueText"] = null;
          field[fi]["i1"]++;
        });
      });

      this.toggleBodyClass("addClass", "dynamic-locker");
      this.doSearch();
    },
    doSearchSleep() {
      this.loading = true;
      let self = this;
      setTimeout(function() {
        self.doSearch();
      }, 3000);
    },
    doSearch() {
      this.users = [];
      this.allDta.projectTaskId = this.obj.id;
      this.allDta.boxSettings.forEach(function(part, bi, box) {
        box[bi]["searchFields"].forEach(function(part2, fi, field) {
          if (field[fi]["value"] != null && field[fi]["value"] != "") {
            field[fi]["isSearch"] = true;
            if (field[fi]["flag"] == 1) {
              field[fi]["valueText"] = field[fi]["value"];
            }
          } else {
            field[fi]["isSearch"] = false;
          }
        });
      });

      //this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "ProjectEdu/GetShinjeech" },
        data: this.allDta,
        store: this.$store,
      }).then((res) => {
        this.loading = false;
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.users = _.orderBy(res.data.tasks, "matchedKeyCount", "desc");
          this.usersTemp = _.orderBy(res.data.tasks, "matchedKeyCount", "desc");
          this.usersCount = res.data.allCount;
          //console.log('GetShinjeech', res);
        }
      });
    },
    visibleChanged(e) {
      console.log("visibleChanged", e);
      if (!e) {
        //this.allDta.boxSettings= [];
        //this.showSidebar = false;
        this.$emit("on-assign-close");
      }
    },
    saveResultRe() {
      this.filterByNameMethodClear();
      let errs = [];
      if (this.users.length == 0) {
        errs.push(
          "Хамгийн багадаа 1 хэрэглэгч хайлтын үр дүнд байх шаардлагатай"
        );
      }

      if (errs.length) {
        Notification.error({
          message: errs[0],
          duration: 5000,
        });
      } else {
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: {
            method: "POST",
            url: "projectEdu/PostShinjeechTask",
          },
          data: {
            taskId: this.obj.id,
            searchOption: JSON.stringify(this.allDta),
            users: this.users.map((u) => {
              return {
                userId: u.userId,
                matchedKeyCount: u.matchedKeyCount,
              };
            }),
          },
          store: this.$store,
        }).then((res1) => {
          console.log("res1", res1);
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res1 != false) {
            Notification.success({
              message: "Хэрэглэгч амжилттай нэмлээ",
              duration: 5000,
            });
            this.visibleChanged(false);
            // this.init();
            // this.fetchAssignedMembers();
            // this.$emit("on-assign-step1", 1);
          }
        });
      }
    },
    saveResult() {
      this.filterByNameMethodClear();
      let errs = [];
      //# negdsen dvn gesen gants hereglegcheer onoo uguh shaardlagatai bolson 1031
      // if(this.users.length<5){
      //   errs.push('Хамгийн багадаа 5 хэрэглэгч хайлтын үр дүнд байх шаардлагатай');
      // }
      if (this.users.length == 0) {
        errs.push(
          "Хамгийн багадаа 1 хэрэглэгч хайлтын үр дүнд байх шаардлагатай"
        );
      }

      // errs.push('obj test');

      if (errs.length) {
        // console.log(this.users.map(u => { return{
        //   userId: u.userId,
        //   userTaskId: u.id,
        //   irtsPerc: u.matchedKeyCount,
        //   executeFlag: -10
        // } }));
        Notification.error({
          message: errs[0],
          duration: 5000,
        });
      } else {
        //console.log('sdf', this.obj);
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: {
            method: "POST",
            url: "TaskInUser/PostNotDynamicUserShareData",
          },
          data: {
            taskId: this.obj.id,
            //executeFlag: -10,
            sharedObjectUsers: this.users.map((u) => {
              return {
                userId: u.userId,
                userTaskId: u.id,
                irtsPerc: u.matchedKeyCount,
                executeFlag: -10,
              };
            }),
          },
          store: this.$store,
        }).then((res1) => {
          console.log("res1", res1);
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res1 != false) {
            this.toggleBodyClass("addClass", "dynamic-locker");
            request({
              api: { method: "GET", url: "Task/GetInherited" },
              params: {
                id: this.obj.id,
                objectTypeId: this.obj.objectTypeId,
                parentId: 0,
                projectId: this.obj.projectId,
                boxId: 0,
                userId: this.$store.state.user.userInfo.userId,
              },
              store: this.$store,
            }).then((res2) => {
              console.log("res2", res2);
              this.toggleBodyClass("removeClass", "dynamic-locker");
              if (res2 != false) {
                let _sdta = res2.data.task;
                _sdta.days = 1;
                _sdta.too2 = null;
                _sdta.s11 = JSON.stringify(this.allDta);
                this.toggleBodyClass("addClass", "dynamic-locker");
                request({
                  api: { method: "POST", url: "Task/PostInherited" },
                  data: { model: _sdta },
                  store: this.$store,
                }).then((res3) => {
                  console.log("res3", res3);
                  this.toggleBodyClass("removeClass", "dynamic-locker");
                  if (res3 != false) {
                    // this.init();
                    // this.fetchAssignedMembers();
                    // this.$emit("on-assign-step1", 1);
                    Notification.success({
                      message: "Тохируулсан хэрэглэгчдийг хадгаллаа",
                      duration: 5000,
                    });
                    this.visibleChanged(false);
                  }
                });
              }
            });
          }
        });
      }
    },
    saveAssign() {
      this.filterByNameMethodClear();
      let errs = [];
      if (
        this.users.filter((x) => x.executeFlag == 10).length <= 3 &&
        this.users.filter((x) => x.executeFlag == 10).length >= 5
      ) {
        errs.push("Төслийн шинжээчдийн бүрэлдэхүүнд 3-5 хүн ажиллах боломжтой");
      }

      //errs.push('obj test');

      if (errs.length) {
        // console.log(
        //   this.users.map(u => { return {
        //       userId: u.userId,
        //       userTaskId: u.id,
        //       irtsPerc: u.irtsPerc,
        //       executeFlag: u.executeFlag
        //     } })
        // );
        Notification.error({
          message: errs[0],
          duration: 5000,
        });
      } else {
        //console.log('sdf', this.obj);
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: {
            method: "POST",
            url: "TaskInUser/PostNotDynamicUserShareData",
          },
          data: {
            taskId: this.obj.id,
            //executeFlag: 10,
            //sharedUsers: this.users.filter(x=>x.executeFlag==10).map(u => { return u.userId; }),
            sharedObjectUsers: this.users.map((u) => {
              return {
                userId: u.userId,
                userTaskId: u.id,
                irtsPerc: u.irtsPerc,
                executeFlag: u.executeFlag,
              };
            }),
            forceUpdate: true,
          },
          store: this.$store,
        }).then((res1) => {
          console.log("res1", res1);
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res1 != false) {
            this.toggleBodyClass("addClass", "dynamic-locker");
            request({
              api: { method: "GET", url: "Task/GetInherited" },
              params: {
                id: this.obj.id,
                objectTypeId: this.obj.objectTypeId,
                parentId: 0,
                projectId: this.obj.projectId,
                boxId: 0,
                userId: this.$store.state.user.userInfo.userId,
              },
              store: this.$store,
            }).then((res2) => {
              // console.log('res2', res2);
              this.toggleBodyClass("removeClass", "dynamic-locker");
              if (res2 != false) {
                let _sdta = res2.data.task;
                _sdta.days = 2;
                _sdta.i8 = 2;
                this.toggleBodyClass("addClass", "dynamic-locker");
                request({
                  api: { method: "POST", url: "Task/PostInherited" },
                  data: { model: _sdta },
                  store: this.$store,
                }).then((res3) => {
                  // console.log('res3', res3);
                  this.toggleBodyClass("removeClass", "dynamic-locker");
                  if (res3 != false) {
                    Notification.success({
                      message: "Шинжээчдийн бүрэлдэхүүн томилогдлоо",
                      duration: 5000,
                    });
                    this.visibleChanged(false);
                    // this.$emit("on-assign-step1", 2);
                  }
                });
              }
            });
          }
        });
      }
    },
    fetchAssignedMembers() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "TaskInUser/GetInheritedNotDynamicList" },
        params: {
          page: 0,
          size: 20000,
          taskId: this.obj.id,
          executeFlag: null, //this.obj.days==2 ? 10 : -10
        },
        store: this.$store,
      }).then((res) => {
        this.loading = false;
        this.toggleBodyClass("removeClass", "dynamic-locker");
        //console.log('GetInheritedNotDynamicList', res);
        if (res != false) {
          let usrs = [];
          if (this.obj.days == 2) {
            usrs = _.orderBy(res.data.users, "executeFlag", "desc");
          } else if (this.obj.days == 1) {
            usrs = _.orderBy(res.data.users, "matchedKeyCount", "desc");
          } else {
            usrs = _.orderBy(res.data.users, "matchedKeyCount", "desc");
          }
          //this.resObj.list = _.orderBy(res.data.logs, "id", "asc");
          usrs.forEach(function(part, ui, user) {
            user[ui]["task"] = user[ui]["firstName"];
            user[ui]["lat"] = user[ui]["lastName"];
            //user[ui]['id']= user[ui]['taskId'];
            user[ui]["id"] = user[ui]["taskId"];
          });
          this.users = usrs;
          this.usersTemp = usrs;
          this.usersCount = usrs.length;
          this.showSidebar = true;
        }
      });
    },

    viewPoints() {
      console.log(this.obj.organizationTask);
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "ProjectEdu/GetPointOptions" },
        params: {
          projectZarTypeId: this.obj.organizationTask.locTypeId,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.pnts.types = res.data.types;
          this.pnts.modal = true;
          //console.log('res', res);
        }
      });
    },
  },
};
</script>
<style>
.test-modal-dialog {
  max-width: 100%;
  margin: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100vh;
  display: flex;
  position: fixed;
  z-index: 100000;
}
</style>
